import React from "react"

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { I18n } from 'react-redux-i18n'

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl:{
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  formLabel: {
    width: '100%'
  }
})

class Color extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <FormControlLabel
          control={
            <Switch
              checked={this.props.updateAppointment.appointmentPrivate}
              onChange={this.props.handlePrivateChange}
              color="primary"
              className={classes.formControl}
            />
          }
          label={I18n.t('editAppointment.private_appointment')}
        />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Color)



// WEBPACK FOOTER //
// ./src/js/components/pages/updateAppointment/Private.js